// extracted by mini-css-extract-plugin
module.exports = {"Belt":"ConveyorBelt_Belt__1jhVJ","BeltBottom":"ConveyorBelt_BeltBottom__1HfAa","WaterPipe":"ConveyorBelt_WaterPipe__3dq4w","animate":"ConveyorBelt_animate__1C5xP"};